import React, { createContext, useContext } from 'react';

type OriginUrlContextType = string | undefined;
const BFFOriginUrlContext = createContext<OriginUrlContextType>(undefined);

type BFFOriginUrlProviderProps = {
	children: React.ReactNode;
	url: OriginUrlContextType;
};
export const BFFOriginUrlProvider = ({
	children,
	url,
}: BFFOriginUrlProviderProps): React.JSX.Element => {
	return <BFFOriginUrlContext.Provider value={url}>{children}</BFFOriginUrlContext.Provider>;
};

export const useBFFOriginUrlContext = (): OriginUrlContextType => {
	return useContext(BFFOriginUrlContext);
};
